import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { MultiStepBar } from 't3-widgets'

import { DeviceTypeHandler } from '../../../../../common/components/device-type-handler/device-type-handler'
import { MOCK_TEST_DATA, TEST_START_PAGE } from '../../../../../common/constants'
import { getCookiesConsent } from '../../common/cookies-utils'
import { CookiesModal } from '../cookies-modal'
import { DynamicPagesHandler } from '../dynamic-pages-handler/dynamic-pages-handler'
import { Footer } from '../footer/footer'
import { AppHeader } from '../header/header'
import { NavigationBar } from '../navigation-bar/navigation-bar'
import { ConfirmationPage } from '../pages/confirmation-page/confirmation-page'
import { CustomerPage } from '../pages/customer-page/customer-page'
import { default as DevicePage } from '../pages/device-page/device-page'
import FinishPage from '../pages/finish-page'
import { SubscriptionPageHandler } from '../pages/subscription-page/subscription-page-handler'

import loaderStyle from '../main-view.module.css'
import styles from './activation-page.module.css'

const ActivationPage = ({ fetchTranslateSuccess, intl }) => {
    const cookiesConsent = getCookiesConsent()
    const [isCookiesModalOpen, setCookiesModalOpen] = useState(!cookiesConsent.setupDone)
    const openCookiesModal = () => setCookiesModalOpen(true)

    const [activeStep, setActiveStep] = useState(MOCK_TEST_DATA ? TEST_START_PAGE : 0)
    const [pagerFunctions, setPagerFunctionsProp] = useState({
        onBack: () => null,
        onFinish: () => null,
        onNext: () => null,
        validator: false
    })

    const setPagerFunctions = funObj => {
        setPagerFunctionsProp(prevState => ({ ...prevState, ...funObj }))
    }

    const loadRawText = (rawText, style) => {
        return fetchTranslateSuccess ? rawText : <div className={loaderStyle[`load-stripe-${style}`]}>.</div>
    }

    const loadText = (stringCodeSuffix, style) => {
        return loadRawText(intl.translate(stringCodeSuffix), style)
    }

    const pagesProps = {
        activeStep,
        fetchTranslateSuccess,
        intl,
        setPagerFunctions,
        setStep: step => setActiveStep(step)
    }

    const getCaption = (currentStep, stringCode) => {
        const desktopCaption = loadText(stringCode, 'caption')
        const mobileCaption = activeStep === currentStep ? desktopCaption : ''

        return (
            <DeviceTypeHandler
                {...{
                    desktopDeviceComponent: desktopCaption,
                    mobileDeviceComponent: mobileCaption
                }}
            />
        )
    }

    const steps = [
        {
            caption: getCaption(0, 'ap_step1_label'),
            page: <CustomerPage {...pagesProps} />
        },
        {
            caption: getCaption(1, 'ap_step2_label'),
            page: <DevicePage {...pagesProps} />
        },
        {
            caption: getCaption(2, 'ap_step3_label'),
            page: <SubscriptionPageHandler {...pagesProps} />
        },
        {
            caption: getCaption(3, 'ap_step4_label'),
            page: <ConfirmationPage {...pagesProps} />
        },
        {
            caption: getCaption(4, 'btn_finish'),
            page: <FinishPage {...pagesProps} />
        }
    ]

    return (
        <div className={styles['app-container']}>
            <div className={styles['wrapper']}>
                <CookiesModal
                    fetchTranslateSuccess={fetchTranslateSuccess}
                    intl={intl}
                    open={isCookiesModalOpen}
                    setOpen={setCookiesModalOpen}
                />
                <AppHeader
                    {...{
                        phoneLabel: '',
                        phoneNumber: '',
                        subtitle: '',
                        title: loadText('ap_name', 'long')
                    }}
                />
                <div className={styles['stepbar-container']}>
                    <MultiStepBar {...{ activeStep, steps }} />
                </div>
                <div className={styles['content-container']}>
                    <div className={styles['page-container']}>
                        <DynamicPagesHandler {...{ activeStep, steps }} />
                    </div>
                </div>
                <div className={styles['navigation-bar-container']}>
                    <NavigationBar
                        {...{
                            activeStep,
                            intl,
                            onActivate: () => pagerFunctions.onActivate(),
                            onBack: () => pagerFunctions.onBack(),
                            onFinish: () => pagerFunctions.onFinish(),
                            onNext: () => pagerFunctions.onNext(),
                            setStep: setActiveStep,
                            steps,
                            valid: pagerFunctions.validator
                        }}
                    />
                </div>
            </div>
            <Footer {...{ intl, loadRawText, openCookiesModal }} />
        </div>
    )
}

ActivationPage.propTypes = {
    fetchTranslateSuccess: PropTypes.boolean,
    intl: PropTypes.objectOf(PropTypes.func)
}

export { ActivationPage }
